module.exports = __webpack_public_path__ + "static/media/Cloud-upload.2991a285.svg";